import React from 'react';
import { Center, Loader } from '@mantine/core';

interface GlobalLoaderProps {
  isLoading: boolean;
  isError: boolean;
  errorMessage?: string;
  children: React.ReactNode;
}

const GlobalLoader: React.FC<GlobalLoaderProps> = ({
  isLoading,
  isError,
  errorMessage = 'Wystąpił błąd podczas ładowania danych.',
  children,
}) => {
  if (isLoading) {
    return (
      <Center style={{ height: '100%' }}>
        <Loader size="lg" />
      </Center>
    );
  }

  if (isError) {
    return (
      <Center style={{ height: '100%' }}>
        <p>{errorMessage}</p>
      </Center>
    );
  }

  return <>{children}</>;
};

export default GlobalLoader;
